module.exports = __webpack_public_path__ + "2fdc9411f90e8861e92089a5162d6e5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_60.jpg
// module id = 1684
// module chunks = 5